// extracted by mini-css-extract-plugin
export default {"cls1":"y_onr2v8s2_uUxhWEH3z","cls2":"yNQLsFWR6egSLi0NMWp7 y_onr2v8s2_uUxhWEH3z"};